import { Rule } from 'antd/lib/form'

import { TextCaptureBlock as TextCaptureBlockType } from '../../types/blueprint'

import { CaptureBlockFormItem } from './CaptureBlockFormItem'

import { Input, TextArea } from '@/components/shared-components/BUI/Input'

type Props = {
  block: TextCaptureBlockType
  rules: Rule[]
}

export const TextCaptureBlock: React.FC<Props> = ({ block, rules }) => {
  const { value, textType, characterLimit, defaultValue } = block

  const commonProps = {
    maxLength: characterLimit,
    defaultValue: defaultValue,
  }

  return (
    <CaptureBlockFormItem block={block} initialValue={value} rules={rules}>
      {textType === 'textArea' ? (
        <TextArea {...commonProps} autoSize={{ minRows: 2, maxRows: 10 }} />
      ) : (
        <Input {...commonProps} type={textType} />
      )}
    </CaptureBlockFormItem>
  )
}
